/**
 * @desc: 对账数据
 * @author: huli
 * @version: v1.0
 */

import request from '@/plugins/http'

// 交易数据
export const getTradeListData = params => {
  return request.get('/check/account/trade/list', params)
}

// 还款数据 
export const getAccountListData = params => {
  return request.get('/check/account/repay/list', params)
}

// 账号信息
export const getCreditListData = params => {
  return request.get('/credit/info/list', params)
}





